import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetBreedersOptionsAction} from '../action';

function* execute({payload}: GetBreedersOptionsAction): SagaIterator {
    const response = yield* call(Api.searchBreedersForPrincipal, {text: payload});

    if (response.isSuccess) {
        yield* put(adminAction.setBreedersOptions(response.data.map(o => ({
            value: o.id,
            label: `${o.registrationNumber} ${o.subjectName ? `- ${o.subjectName}` : ''}`,
        }))));
    } else {
        yield putAll(showBeError(response, t('userDetail')('loadBreeders')));
    }
}
/** Runs the admin saga that loads breeder options for the management form. */
export function* getManagementBreederOptionsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_BREEDERS_OPTIONS', execute);
}
